import request from "@/utils/request";
import Qs from "qs";

const api = {
  findPage: "/openapi/jSunWorkers/findPage",
  upload: "/openapi/jSunWorkers/workUpload",
  approvalWork: "/openapi/jSunWorkers/approvalWork",
  count: "/openapi/jSunWorkers/workersCount",
  resource: "/openapi/jTypes/topFindByWorkeId"
};

/**
 * 分页查询
 * @param parameter
 * @returns {*}
 */
export function findPage(parameter) {
  return request({
    url: api.findPage,
    method: "get",
    params: parameter
  });
}

/**
 * 教师端任务上传
 * @param parameter
 * @returns {*}
 */
export function upload(parameter) {
  return request({
    url: api.upload,
    method: "get",
    params: parameter
  });
}

/**
 * 任务资源审批接口
 * @param parameter
 * @returns {*}
 */
export function approvalWork(parameter) {
  return request({
    url: api.approvalWork,
    method: "POST",
    data: Qs.stringify(parameter)
  });
}

/***
 * 功能描述：获取统计数据 <br>
 * 〈〉
 * @Param parameter
 * @Return 统计数据
 * @Author CHU
 * @Date 14:11 2021/2/19
 **/
export function count(parameter) {
  return request({
    url: api.count,
    method: "get",
    params: parameter
  });
}
/***
 * 功能描述：资源目录<br>
 * 〈〉
 * @Param parameter
 * @Return 资源目录数据
 *
 **/
export function resource(parameter) {
  return request({
    url: api.resource,
    method: "get",
    params: parameter
  });
}
